import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <Link to="/" className="text-gray-900 dark:text-white font-medium hover:text-blue-600 dark:hover:text-blue-400 transition-colors">
            Tezos Marketplace
          </Link>
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            Created by{' '}
            <a
              href="https://x.com/austingray"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 hover:underline"
            >
              auger
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
